import React, { useState } from 'react';
import { Row, Col, ImageBadge, VideoTile } from 'seduo-ui';
const Example = () => {
    const [muted, setMuted] = useState(true);
    const handleChangeMuted = (newMuteState) => {
        setMuted(newMuteState);
    };
    return (<Row>
            <Col md={6}>
                <VideoTile href="#" title="Moric test kurz" lector="Pavel Moric" imageSrc="https://dummyimage.com/520x350/9fa4a8/fff.png" overlay={{ bottomLeft: <ImageBadge theme="dark" text="1h 55min"/> }} video={{
            src: 'https://lmc-vod.ssl.cdn.cra.cz/0143/9518/cze-hd2-s0U5SoTh.mp4',
            type: 'video/mp4',
            muted,
        }} onChangeMute={handleChangeMuted}/>
            </Col>
            <Col md={6}>
                <VideoTile title="Program test kurz" lector="Pavel Moric" imageSrc="https://dummyimage.com/520x350/9fa4a8/fff.png" overlay={{
            bottomLeft: (<>
                                <ImageBadge text="4 kurzy"/>
                                <ImageBadge text="1h 55min"/>
                            </>),
            topLeft: <ImageBadge icon="education" text="Vzdělávací program" theme="dark"/>,
        }} video={{
            src: 'https://lmc-vod.ssl.cdn.cra.cz/0143/9518/cze-hd2-s0U5SoTh.mp4',
            type: 'video/mp4',
            muted,
        }} onChangeMute={handleChangeMuted}/>
            </Col>
        </Row>);
};
export default Example;
